import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classes from 'classnames';
import Login from './login';
import Register from './register';
import {submitRegister, submitLogin, showResetPassword} from "../../../Auth/Actions";


class CustomerAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowLogin: true,
      isShowRegistration: false,
    };
  }

  showLogin = () => {
    this.setState({isShowLogin: true, isShowRegistration: false}, () => {
      this.props.onChangedTemplate()
    })
  };

  showRegistration = () => {
    this.setState({isShowLogin: false, isShowRegistration: true}, () => {
      this.props.onChangedTemplate()
    });
  };

  render() {
    const {
      isShowLogin,
      isShowRegistration,
    } = this.state;

    const {
      error,
      register,
      login,
      authRegisterPromise,
      showResetPass,
    } = this.props;

    return (
      <div className="booking__authorization">
        <div className="booking__authorization-wrap">
          <ul className="booking__authorization-list">
            {
              isShowLogin &&
              <li
                className={classes('booking__authorization-item', {active: isShowLogin})}
                role="presentation"
                onKeyDown={() => {
                }}
                onClick={this.showLogin}
              >
                Sign in
              </li>
            }
            {
              isShowRegistration &&
              <li
                className={classes('booking__authorization-item', {active: isShowRegistration})}
                role="presentation"
                onKeyDown={() => {
                }}
                onClick={this.showRegistration}
              >
                Sign up
              </li>
            }
          </ul>
          {
            isShowLogin &&
            <Login
              error={error}
              submit={login}
              showRegistration={this.showRegistration}
              showResetPassword={showResetPass}
            />
          }
          {
            isShowRegistration &&
            <Register
              error={error}
              submit={register}
              authRegisterPromise={authRegisterPromise}
              login={login}
              showLogin={this.showLogin}
            />
          }
        </div>
      </div>
    );
  }
}

CustomerAuth.propTypes = {
  error: PropTypes.object,
  register: PropTypes.func,
  login: PropTypes.func,
  authRegisterPromise: PropTypes.object,
  showResetPass: PropTypes.func,
  onChangedTemplate: PropTypes.func,
};

const stp = (s) => ({
  error: s.auth.error,
  authRegisterPromise: s.auth.promise.register
});


const dtp = (d) => ({
  register: (data) => {
    d(submitRegister(data))
  },
  login: (data) => {
    d(submitLogin(data))
  },
  showResetPass: (data) => {
    d(showResetPassword(data))
  }
});


export default connect(stp, dtp)(CustomerAuth);


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/auth/index.js